import { COMMITTEE_PARTICIPANT } from '../actions';
import '../global';

export default ( state = isCommitteeParticipant(), action ) => {
	switch ( action.type ) {
		case COMMITTEE_PARTICIPANT:
			return action.payload;
			break;
	}
	return state;
}